import { useContext, useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { InputAdornment } from "@mui/material";
import { Context } from "../DashCrearSolicitudCredito";
import { GetKey, GetText } from "../../../../../Helpers/GetKey";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import WcIcon from "@mui/icons-material/Wc";
import CakeIcon from "@mui/icons-material/Cake";
import FavoriteIcon from "@mui/icons-material/Favorite";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import request from "../../../../../Helpers/API";
import Swal from "sweetalert2";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
const SolicitudDeCreditoGeneralesFisica = ({
  setValue,
  setScreen,
  screen,
  cliente,
  onNext,
  value,
  setBotonSiguiente,
}) => {
  const { state } = useContext(Context);
  const [datosgenerales, setDatosGenerales] = useState({
    rfc: "",
    tipo_persona: "",
    curp: "",
    razon_social: "",
    sexo: "",
    edad: "",
    estado_civil: "",
    regimen_conyugal: "",
    agrupacion: "",
    agrupaciondesc: "",
    tiempo_agricultor: "",
  });

  const onSiguiente = () => {
    setValue(1);
  };
  useEffect(() => {
    setBotonSiguiente(() => (
      <div
        className="footer-solicitud-credito-guardar"
        onClick={() => onNext(value + 1)}
      >
        Siguiente <ArrowForwardIcon />
      </div>
    ));
  }, []);
  useEffect(() => {
    // setLoader({ ...loader, mostrar: true });
    request
      .get(`Clientes/BuscarID?idcliente=${state.idCliente}`)
      .then((result) => {
        setDatosGenerales({
          ...datosgenerales,
          rfc: result.rfc,
          tipo_persona: result.tipo_persona,
          curp: result.curp,
          razon_social: result.razon_social,
          sexo: result.sexo,
          edad: result.edad,
          estado_civil: result.estado_civil,
          regimen_conyugal: result.regimen_conyugal,
          agrupacion: result.agrupacion,
          agrupaciondesc: result.agrupaciondesc,
          tiempo_agricultor: result.tiempo_agricultor,
        });
        // setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire({
          icon: "error",
          title: "SOLICITUD DE CREDITO",
          text: `${JSON.stringify(error)}`,
        });
      });
  }, []);
  return (
    <div>
      <FormControl fullWidth>
        <div className="dash-clientes-credito-crear-solicitud-form-container scroll">
          <TextField
            inputProps={{ className: "textfield", readOnly: true }}
            fullWidth
            size="small"
            label="RFC"
            variant="outlined"
            value={datosgenerales.rfc}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKeyIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            size="small"
            label="Tipo persona"
            variant="outlined"
            inputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            value={GetText(datosgenerales.tipo_persona)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PeopleIcon />
                </InputAdornment>
              ),
            }}
          />
          {GetKey(datosgenerales.tipo_persona) === "F" && (
            <TextField
              fullWidth
              size="small"
              label="CURP"
              variant="outlined"
              inputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
              value={datosgenerales.curp}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <VpnKeyIcon />
                  </InputAdornment>
                ),
              }}
            />
          )}
          <div className="full">
            <TextField
              fullWidth
              size="small"
              label="Razon social"
              variant="outlined"
              value={datosgenerales.razon_social}
              inputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <BusinessIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {GetKey(datosgenerales.tipo_persona) === "F" && (
            <div className="mid">
              <TextField
                fullWidth
                size="small"
                label="Sexo"
                variant="outlined"
                inputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                value={GetText(datosgenerales.sexo)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <WcIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                size="small"
                label="Edad"
                variant="outlined"
                inputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                value={datosgenerales.edad}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CakeIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                size="small"
                label="Estado civil"
                variant="outlined"
                inputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                value={GetText(datosgenerales.estado_civil)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FavoriteIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                size="small"
                label="Régimen conyugal"
                variant="outlined"
                inputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                value={GetText(datosgenerales.regimen_conyugal)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FavoriteIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          )}

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Nivel de agrupación"
            inputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            value={datosgenerales.agrupaciondesc}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GroupWorkIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            size="small"
            label="Tiempo de agricultor"
            variant="outlined"
            inputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            value={datosgenerales.tiempo_agricultor}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccessTimeIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </FormControl>
    </div>
  );
};

const SolicitudDeCreditoGeneralesMoral = () => {};

export { SolicitudDeCreditoGeneralesFisica, SolicitudDeCreditoGeneralesMoral };
